import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import * as CONSTANTS from "./constants";

class Button extends React.Component {
  render() {
    const buttonClasses = classNames(
      "button",
      {
        [`size-${this.props.size}`]: this.props.size,
        [`${this.props.theme}`]: !this.props.disabled,
        [`margin-${this.props.margin}`]: this.props.margin,
        outline: this.props.outline,
        block: this.props.block,
        circle: this.props.circle,
        vertical: this.props.vertical,
        "with-icon": this.props.icon
      },
      this.props.className
    );

    if (this.props.type === "as") {
      const { as, to } = this.props;

      return React.createElement(
        as,
        {
          to,
          style: this.props.style,
          className: buttonClasses,
          disabled: this.props.disabled
        },
        this.props.children
      );
    }

    return React.createElement(
      "button",
      {
        style: this.props.style,
        className: buttonClasses,
        name: this.props.name,
        type: this.props.type,
        tabIndex: this.props.tabIndex,
        disabled: this.props.disabled,
        onClick: this.props.onClick,
        onBlur: this.props.onBlur,
        onFocus: this.props.onFocus
      },
      this.props.children
    );
  }
}

Button.defaultProps = {
  name: null,
  type: "button",
  theme: "default",
  tabIndex: null,
  as: null,
  size: null,
  outline: false,
  block: false,
  disabled: false,
  circle: false,
  icon: null,
  margin: null,
  vertical: null,
  onClick: null,
  onBlur: null,
  onFocus: null,
  className: null,
  style: {},
  children: null
};

Button.propTypes = {
  name: PropTypes.string,
  //     /** Текст кнопки */
  //     // text: Type.node,
  //     /** Иконка кнопки */
  //     // icon: Type.node,
  //     /** Список произвольных элементов в левом слоте */
  //     // rightAddons: Type.node,
  //     /** Список произвольных элементов в правом слоте */
  //     // leftAddons: Type.node,
  //     /** Тип кнопки */
  //     // view: Type.oneOf(['default', 'action', 'extra']),
  /** Поведение кнопки */
  type: PropTypes.oneOf(CONSTANTS.TYPE),
  //     /** HTML элемент, которым будет компонент в DOM */
  //     tag: Type.oneOf(['button', 'span']),
  //     /** Управление шириной кнопки. При значении 'block'
  // растягивает кнопку на ширину родителя */
  //     width: Type.oneOf(['default', 'block']),
  /** В виде компонента */
  as: PropTypes.oneOfType([PropTypes.node, PropTypes.func, PropTypes.element]),
  /** Размер компонента */
  size: PropTypes.oneOf(CONSTANTS.SIZE),
  /** Стиль компонента */
  theme: PropTypes.oneOf(CONSTANTS.THEME),
  /** Имеет только линию */
  outline: PropTypes.bool,
  block: PropTypes.bool,
  /** Отключенная кнопка */
  disabled: PropTypes.bool,
  /** Круглая кнопка */
  circle: PropTypes.bool,
  icon: PropTypes.node,
  margin: PropTypes.oneOf([false, "no"]),
  vertical: PropTypes.bool,
  tabIndex: PropTypes.string,
  onClick: PropTypes.func,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  style: PropTypes.object,
  children: PropTypes.node
};

export default Button;
